import React, { useState } from "react";

export default function Button({ children, variant = "primary", onClick, style, acc, disabled = false }) {
  const [hov, setHov] = useState(false);
  const isPrimary = variant === "primary";
  const isOutline = variant === "outline";
  return (
    <button
      type="button"
      onMouseEnter={() => !disabled && setHov(true)}
      onMouseLeave={() => setHov(false)}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      style={{
        padding: "12px 28px",
        borderRadius: 12,
        border: isOutline ? `1px solid ${acc.primary}88` : "none",
        background: isPrimary
          ? `linear-gradient(135deg, ${acc.primary}cc, ${acc.tertiary}cc)`
          : isOutline
          ? hov
            ? `${acc.primary}18`
            : "transparent"
          : "transparent",
        color: isPrimary ? "#fff" : acc.primary,
        fontFamily: "'DM Sans', sans-serif",
        fontWeight: 500,
        fontSize: 15,
        letterSpacing: "0.01em",
        cursor: disabled ? "not-allowed" : "pointer",
        transition: "all 0.25s ease",
        transform: hov && !disabled ? "translateY(-1px)" : "none",
        boxShadow: isPrimary && hov && !disabled ? `0 8px 24px ${acc.primary}33` : "none",
        opacity: disabled ? 0.65 : 1,
        ...style
      }}
    >
      {children}
    </button>
  );
}
